(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/cms-document/assets/javascripts/cms-document.js') >= 0) return;  svs.modules.push('/components/accountservices/cms-document/assets/javascripts/cms-document.js'); "use strict";


(function (svs) {
  'use strict';

  const logger = svs.core.log.getLogger('components:cms-document');

  function getTermLink(term, docLinkText) {
    const isApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp') ? svs.core.config.data.svsconfig.isNativeApp : false;
    logger.info("Getting term link for ".concat(term));
    if (svs.utils.ns.isNamespace('svs.accountservices.cms_document.data') && svs.accountservices.cms_document.data.hasOwnProperty(term) && svs.accountservices.cms_document.data[term].url) {
      const docLink = svs.accountservices.cms_document.data[term].url;
      if (isApp) {
        return "<a href=\"".concat(docLink, "\">").concat(docLinkText, "</a>");
      }
      return "<a href=\"".concat(docLink, "\" target=\"_blank\">").concat(docLinkText, "</a>");
    }
    logger.warn("Could not get term link for ".concat(term));
    return "<a href=\"".concat(svs.utils.url.makeInternal(svs.core.urlMapping.get('termsIntegrityTerms'), svs.core.urlMapping.get('startPage')), "\"").concat(isApp ? '' : ' target="_blank"', ">").concat(docLinkText, "</a>");
  }
  svs.accountservices.cms_document.getTermLink = getTermLink;
})(svs);
 })(window);